<div class="column-layout-container">
  <div class="menu animate-in-from-left" [class.mobile-shown]="appService.mobileMenuShown">
    <div class="menu-top d-flex justify-content-between align-items-center">
      <fui-heading [text]="'Metro' | translate" [level]="5"></fui-heading>
      <div>
        <button class="fa-button m-r-10" placement="bottom" [ngbTooltip]="'metro.new_connection' | translate" (click)="addConnection()">
          <fa-icon icon="plus" class="action create-action circle-icon-btn"></fa-icon>
        </button>
        <button class="fa-button m-r-10" placement="bottom" [ngbTooltip]="(refreshing ? 'general.refreshing_dots' : 'general.refresh') | translate" (click)="refresh()">
          <fa-icon icon="sync" class="action circle-icon-btn" [animation]="refreshing ? 'spin' : undefined"></fa-icon>
        </button>
      </div>
    </div>

    <myp-inline-loader [loading]="loading" height="200px" spinnerName="satelliteLoader"></myp-inline-loader>

    <ul class="menu-options">
      <li
        tabindex="0"
        class="menu-option detailed"
        (keyup.enter)="appService.mobileMenuShown = false; selectLink('get_started')"
        (click)="appService.mobileMenuShown = false; selectLink('get_started')"
        [class.active]="!selectedLinkedUser"
      >
        <div class="primary-option">
          <div class="d-flex">
            <img
              class="image-border"
              [src]="
                appService.selectedTheme == 'auto'
                  ? appService.systemTheme == 'dark'
                    ? './assets/icons/metro-logo.png'
                    : './assets/icons/metro-logo-black.png'
                  : appService.selectedTheme == 'plaindark'
                    ? './assets/icons/metro-logo.png'
                    : './assets/icons/metro-logo-black.png'
              "
            />
            <div>
              <span class="title">{{ "metro.get_started" | translate }}</span>
              <br />
              <span class="extra-info">{{ "metro.get_started_description" | translate }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>

    @if (!loading && !linkedUsers.length) {
      <div class="m-y-20 m-x-10">{{ "metro.no_connections_message" | translate }}</div>
    }
    @if (linkedUsers && linkedUsers.length) {
      <ul class="menu-options">
        @for (item of linkedUsers; track item) {
          <li
            tabindex="0"
            class="menu-option detailed"
            (keyup.enter)="appService.mobileMenuShown = false; selectLink(item.id)"
            (click)="appService.mobileMenuShown = false; selectLink(item.id)"
            [class.active]="item.id == selectedLinkedUser?.id"
          >
            <div class="primary-option">
              <div class="d-flex align-items-center primary-option-title">
                <img class="image-border" [src]="item.photo || './assets/images/default_avatar.jpg'" />
                <div>
                  <span class="title">{{ item.name ? item.name : item.email }}</span>
                  <br />
                  <span class="extra-info">STATUS: {{ item.status.toUpperCase() }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <fa-icon icon="ellipsis-h" (click)="connectionOptions(item, $event)" placement="left" [ngbTooltip]="'sphere.options' | translate" class="action circle-icon-btn"></fa-icon>
                @if (item.favorite) {
                  <fa-icon icon="star" (click)="favoriteUser(item, $event)" placement="left" [ngbTooltip]="'sphere.unfavorite' | translate" class="action orange m-l-5 circle-icon-btn"></fa-icon>
                }
              </div>
            </div>
          </li>
        }
      </ul>
    }
  </div>
  <div class="content animate-in-from-right" [class.mobile-shown]="!appService.mobileMenuShown">
    <div class="mobile-back-btn" (click)="appService.mobileMenuShown = true">
      <fa-icon icon="chevron-left"></fa-icon>
      Metro
    </div>
    @if (selectedLinkedUser) {
      <div class="content-constrained">
        <myp-shared-satellite-detail (connectionUpdated)="refresh()" [connectionData]="selectedLinkedUser"></myp-shared-satellite-detail>
      </div>
    } @else {
      <div class="row h-100">
        <div class="col h-100 text-center">
          <div class="h-100 d-flex justify-content-center align-items-center">
            <div style="max-width: 600px; margin: 10px">
              <div>
                <fui-heading textAlign="center" [text]="'Metro'" [level]="1"></fui-heading>
                <p>
                  {{ "metro.description" | translate }}
                </p>
                <h4 class="brandfont-bold">{{ "metro.watch_video" | translate }}</h4>
                <div class="position-relative pointer" (click)="watchMetroVideo()">
                  <img src="https://i.ytimg.com/vi/CAL3CrKiTgU/hqdefault.jpg" style="width: 90%; max-width: 300px; margin: auto" alt="video thumbnail" />
                  <div class="play-indicator" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center">
                    <fa-icon icon="play-circle" class="t-40"></fa-icon>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <button class="btn btn-primary" (click)="downloadUC()">{{ "metro.download_uc" | translate }}</button>
              &nbsp;&nbsp;&nbsp;
              <button class="btn btn-primary" (click)="downloadManual()">{{ "metro.reference_manual" | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
